// extracted by mini-css-extract-plugin
export default {"settingTable":"TableColumnConfig_settingTable__GJXZt"};